


import { createContext, useContext, useState, useEffect } from 'react';
import {
    fetchCustomerLocation,
    fetchRequestedServices
} from '../../Api/serviceApiMaster'; // Update path as needed

const ServiceContext = createContext();

export const ServiceProvider = ({ children }) => {
    const [customerLoc, setcustomerLoc] = useState([]);
    const [requestServiceData, setRequestServiceData] = useState([]);



    const loadCustomerLocation = async (customerCode) => {
        try {
            const data = await fetchCustomerLocation(customerCode?.customerId);
            // console.log(data, 'data of body types')
            setcustomerLoc(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadRequestServices = async () => {
        try {
            const data = await fetchRequestedServices();
            // console.log(data, 'data of body types')
            setRequestServiceData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    return (
        <ServiceContext.Provider
            value={{
                customerLoc,
                loadCustomerLocation,
                requestServiceData,
                loadRequestServices
            }}
        >
            {children}
        </ServiceContext.Provider>
    );
};

export const useServiceContext = () => useContext(ServiceContext);



